import React, { FC, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import { ImgixImageType } from "@srcTypes"

import { getImgixImageData } from "@utils"

import PlayButton from "@components/PlayButton/PlayButton"
import Wistia from "../Wistia/Wistia"

import "./WistiaWithPreview.scss"

type WistiaWithPreviewProps = {
  aspectRatio?: number
  id: string
  previewImageSrc?: string
  previewImageData?: ImgixImageType
  title: string
}

const WistiaWithPreview: FC<WistiaWithPreviewProps> = ({
  aspectRatio = 16 / 9,
  id,
  previewImageSrc,
  previewImageData,
  title,
}) => {
  const [showVideo, setShowVideo] = useState(false)
  return (
    <div className="WistiaWithPreview">
      {showVideo ? (
        <Wistia autoPlay id={id} />
      ) : (
        <div
          className="WistiaWithPreview--Preview"
          onClick={() => setShowVideo(true)}
        >
          {previewImageData ? (
            <GatsbyImage alt={title} image={previewImageData.gatsbyImageData} />
          ) : (
            <GatsbyImage
              alt={title}
              image={getImgixImageData(previewImageSrc, 1200, aspectRatio)}
            />
          )}
          <PlayButton />
        </div>
      )}
    </div>
  )
}

export default WistiaWithPreview
